import { useCompetitionTypeListQuery } from '../types/queries';
import { BaseFormState } from '~/types/BaseFormState';
import { ForwardedRef, forwardRef } from 'react';
import { FormState } from 'react-hook-form';
import { Input } from '~/components/Input';

interface Props<TFormState extends BaseFormState> {
  onChange?: (values: number[]) => void;
  formState?: FormState<TFormState>;
  disabled?: boolean;
  value?: number[];
}

function CompetitionTypeMultiSelectElement<TFormState extends BaseFormState>(
  props: Props<TFormState>,
  ref: ForwardedRef<HTMLSelectElement>
) {
  const { data = [], isLoading } = useCompetitionTypeListQuery();

  return (
    <Input.MultiSelect
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      disabled={props.disabled || isLoading}
      options={data.map(o => [o.description, o.id])}
      placeholder="Välj tävlingstyper"
      ref={ref}
      {...props}
    />
  );
}

export const CompetitionTypeMultiSelect = forwardRef(CompetitionTypeMultiSelectElement) as <
  TFormState extends BaseFormState,
>(
  props: Props<TFormState> & { ref?: ForwardedRef<HTMLSelectElement> }
) => ReturnType<typeof CompetitionTypeMultiSelectElement>;
